/** @format */

export default {
  state: {},
  mutations: {},
  actions: {},
}
